import request from '@/utils/httpRequest'

export default class ExtensionBidService {
    queryById(id) {
        return request({
            url: '/extension/wuyeExtensionBid/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow(params) {
        return request({
            url: '/extension/wuyeExtensionBid/startFlow',
            method: 'post',
            data: params
        })
    }

}
